// removed by extract-text-webpack-plugin
module.exports = {"card":"theme--card--1QbA7xdU","poster":"theme--poster--38_QCOYN","title":"theme--title--2jjte8zx"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/trainingCard/theme.scss
// module id = 1041
// module chunks = 0